<div class="dialog-container">
  <div layout="row" layout-align="space-between center" flex>
    <span mat-dialog-title>Верификация на Самоличност</span>
    <button tabindex="-1"
            mat-icon-button
            class="close-button"
            [disabled]="isLoading"
            (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <hr>

  @if (!isLoading) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-dialog-content>

        <mat-form-field appearance="outline" class="kse-state">
          <mat-label>Статус</mat-label>
          <mat-select formControlName="state">

            <mat-select-trigger>
              @let currentValue = form.get('state')?.value;
              @for (opt of STATE_OPTIONS; track opt.value) {
                @if (opt.value === currentValue) {
                  <span class="kse-option">
                    <mat-icon class="kse-option__icon" [ngStyle]="{ color: opt.color }">
                      {{ opt.icon }}
                    </mat-icon>
                    <span>
                      {{ 'verification.kycState.' + opt.value | translate }}
                    </span>
                  </span>
                }
              }
            </mat-select-trigger>

            @for (opt of STATE_OPTIONS; track opt.value) {
              <mat-option [value]="opt.value"
                          [disabled]="!opt.editable && opt.value !== data.currentState"
                          [matTooltip]="!opt.editable ? ('verification.kycState.notEditableTooltip' | translate) : ''"
                          matTooltipPosition="left">
                <span class="kse-option">
                  <mat-icon class="kse-option__icon" [ngStyle]="{ color: opt.color }">
                    {{ opt.icon }}
                  </mat-icon>
                  <span class="kse-option__name">
                    {{ 'verification.kycState.' + opt.value | translate }}
                  </span>
                  @if (!opt.editable) {
                    <mat-icon class="kse-option__lock">lock</mat-icon>
                  }
                </span>
              </mat-option>
            }

          </mat-select>
        </mat-form-field>

      </mat-dialog-content>

      <div flex layout="row" layout-align="center center">
        <button flex
                type="submit"
                color="primary"
                mat-raised-button
                [disabled]="form.get('state')?.value === data.currentState">
          {{ 'global.save' | translate }}
        </button>
      </div>
    </form>
  } @else {
    <div class="progress-spinner-container detail-spinner">
      <mat-spinner class="progress-spinner"
                   strokeWidth="10"
                   [diameter]="100"></mat-spinner>
    </div>
  }
</div>